import type { VueQueryPluginOptions } from '@tanstack/vue-query'
import { datadogRum } from '@datadog/browser-rum'
import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental'
import {
  dehydrate,
  hydrate,
  QueryCache,
  QueryClient,
  VueQueryPlugin,

} from '@tanstack/vue-query'
import { ValiError } from 'valibot'
import { createQueryRetry } from '~/utils/query-retry'

const FIVE_MINUTES = 1000 * 60 * 5

export default defineNuxtPlugin((nuxt) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: FIVE_MINUTES,
        retry: createQueryRetry(import.meta.server),
      },
    },
    queryCache: new QueryCache({
      onError(error, query) {
        const meta: Record<string, unknown> = {
          resource: query.queryKey,
        }

        if (error instanceof ValiError) {
          meta.issues = error.issues
        }

        if (import.meta.server || import.meta.dev) {
          console.error(error, meta)
        }
        else if (import.meta.client) {
          datadogRum.addError(error, meta)
        }
      },
    }),
  })

  const options: VueQueryPluginOptions = { queryClient }

  nuxt.vueApp.use(VueQueryPlugin, options)

  if (import.meta.server) {
    nuxt.hooks.hook('app:rendered', () => {
      nuxt.payload.query = dehydrate(queryClient)
    })
  }

  if (import.meta.client) {
    broadcastQueryClient({ queryClient })
    hydrate(queryClient, nuxt.payload.query)
  }
})
